export class TreasuryTransactionTypeDetail {
  code?: string;
  balance?: number;
  intervalBalance?: number;
  totalRecords?: number;
  intervalTotalRecords?: number;
}

export class TreasuryBankingSummaryResponseDto {
  businessEntityId: number;
  businessEntityBankId?: number;
  balance?: number;
  intervalBalance?: number;
  totalRecords?: number;
  intervalTotalRecords?: number;
  transactionTypeDetails?: TreasuryTransactionTypeDetail[];
}
